export class SearchFormatter {
    static formatSearch(value: string, searchTerm: string) {
        if (value == null || value == '') {
            return value;
        }

        const regex = new RegExp(`(${searchTerm})`, 'gi');
		return value.replace(regex, '<strong>$1</strong>');
    }
}